module.exports = __webpack_public_path__ + "static/media/9.71522701.jpeg";